module.exports = __webpack_public_path__ + "static/media/belote_rebelote_only.b87a5ee0.svg";